<template lang="pug">
  v-layout(align-start='')
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='tipoEmpleado' :items='tipoEmpleado' :search='search' sort-by='descripcion' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color="primary" dark)
            v-toolbar-title(class="justify-center") Tipo de Empleado
            v-divider.mx-4(inset='' vertical='')
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line='' hide-details='' color='success')
            v-spacer
            v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' @click='dialog = true')
              v-icon(dark) mdi-plus
            Tipo-empleado-m(
              :dialog='dialog',
              :editedIndex='editedIndex',
              @close='close',
              :read='read',
              :FormPadre='form',
              @save='listarTipo',
              @edited='listarTipo')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='validarModificar()' color='warning' @click='editItem(item)' v-on="on") mdi-pencil
            | Editar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
        template(v-slot:no-data='')
          h1 No hay datos
</template>

<script>
import Api from '@/services/methods';
import TipoEmpleadoM from '@/components/modals/TipoEmpleadoM';
export default {
  components: {
    TipoEmpleadoM
  },

  data: () => ({
    read: false,
    dialog: false,
    loading: true,
    headers: [
      {
        text: 'Descripcion',
        align: 'center',
        sortable: false,
        value: 'descripcion'
      },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    tipoEmpleado: [],

    search: '',
    ruta: '',
    head: [
      { text: 'Ruta', value: 'ruta', align: 'center' },
      { text: 'Acciones', value: 'accion', align: 'center' },
      { text: 'Accion', value: 'action', align: 'center' }
    ],
    item2: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte'],
    item: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte'],
    listado: [],
    accion: '',
    permisosRuta: {},
    options: ['Ver', 'Crear', 'Modificar', 'Eliminar'],
    editedIndex: -1,
    form: {
      permisos: [],
      list: [],
      descripcion: ''
    },

    defaultItem: {
      permisos: [],
      list: [],
      descripcion: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Tipo de Empleado'
        : 'Modificar Tipo de Empleado'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.listarTipo();
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'TipoEmpleado');
    },
    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear');
    },

    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar');
    },

    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar');
    },

//     deleteItem2 (item) {
//       this.$swal
//         .fire({
//           title: '¿Estás seguro?',
//           text: 'No podrás revertir esta operación!',
//           icon: 'warning',
//           showCancelButton: true,
//           confirmButtonColor: '#3085d6',
//           cancelButtonColor: '#d33',
//           confirmButtonText: 'Si, Eliminar!'
//         })
//         .then(result => {
//           if (result.value) {
//             for (let i = 0; i < this.form.permisos.length; i++) {
//               if (this.form.permisos[i].ruta === item.ruta) {
//                 this.form.permisos.splice(i, 1)
//                 this.listado.splice(i, 1)
//                 this.item.push(item.ruta)
//               }
//             }
//             this.form.list = this.listado
//           }
//         })
//     },
// 
//     AllPermisos () {
//       this.ruta = ''
//       this.accion = ''
//       this.listado = []
//       this.form.list = []
//       this.form.permisos = []
//       // this.editedItem.permisos = []
//       for (let i = 0; i < this.item2.length; i++) {
//         this.listado.push({
//           ruta: this.item2[i],
//           accion: 'Ver Crear Modificar Eliminar'
//         })
//         this.form.permisos.push({ ruta: this.item2[i], accion: this.options })
//         // this.editedItem.permisos.push({ ruta: this.item2[i], accion: this.options })
//       }
//       this.form.list = this.listado
//       this.$swal('Felicidades.!', 'Permisos Agregados con Exito.', 'success')
//       this.item = []
//     },
// 
//     DeleteAllPermisos () {
//       this.ruta = ''
//       this.accion = ''
//       this.listado = []
//       this.form.list = []
//       this.form.permisos = []
//       // this.editedItem.permisos = [];
//       this.item = []
//       for (let i = 0; i < this.item2.length; i++) {
//         this.item.push(this.item2[i])
//       }
//       this.$swal('Felicidades.!', 'Permisos Eliminados con Exito.', 'success')
//     },
// 
//     add (ruta, accion) {
//       let bols = false
//       let view = false
//       if (ruta && accion) {
//         for (let j = 0; j < accion.length; j++) {
//           if (accion[j] === 'Ver') {
//             view = true
//           }
//         }
//         if (view === true) {
//           if (this.form.permisos.length > 0) {
//             for (let i = 0; i < this.form.permisos.length; i++) {
//               for (let j = 0; j < ruta.length; j++) {
//                 if (this.form.permisos[i].ruta === ruta[j]) {
//                   bols = true
//                 }
//               }
//             }
//           }
// 
//           if (bols === false) {
//             let stg = ''
//             for (let e = 0; e < accion.length; e++) {
//               stg += accion[e] + ' '
//             }
//             for (let i = 0; i < ruta.length; i++) {
//               this.listado.push({ ruta: ruta[i], accion: stg })
//               this.form.permisos.push({ ruta: ruta[i], accion: accion })
//               for (let j = 0; j < this.item.length; j++) {
//                 if (ruta[i] === this.item[j]) {
//                   this.item.splice(j, 1)
//                 }
//               }
//             }
//             this.form.list = this.listado
//             this.$swal(
//               'Felicidades.!',
//               'Permiso Agregado con Exito.',
//               'success'
//             )
//             this.ruta = ''
//             this.accion = ''
//           } else {
//             this.$swal(
//               'Oops...',
//               'Ya posee en la lista esta misma ruta, eliminela y vuelva a añadir si desea modificarla.',
//               'error'
//             )
//           }
//         } else {
//           this.$swal(
//             'Oops...',
//             'Para agregar esta o estas acciones a la lista es necesario incluir la acción (VER) en la misma.',
//             'error'
//           )
//         }
//       } else {
//         this.$swal(
//           'Oops...',
//           'Debe ingresar ambos campos( ruta y accion ) para poder agregarlo a la lista.',
//           'error'
//         )
//       }
//       console.log('Listado')
//       console.log(this.listado)
// 
//       console.log('LIST')
//       console.log(this.form.list)
//     },

    listarTipo () {
      // this.listado = []
      // this.form.list = []
      Api.get('tipoEmpleado')
        .then(response => {
          this.tipoEmpleado = response.data
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    editItem (item) {
      this.editedIndex = this.tipoEmpleado.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true

      // for (let i = 0; i < this.form.list.length; i++) {
      //   this.listado.push(this.form.list[i])
      // }

//       console.log('LISTADO')
//       console.log(this.listado)
// 
//       console.log('LIST')
//       console.log(this.form.list)
    },

    deleteItem (item) {
      const index = this.tipoEmpleado.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.tipoEmpleado.splice(index, 1)
          Api.delete('/tipoEmpleado/' + item._id).then(response => {
            console.log(response)
          })
        }
      })
    },

    close () {
      this.dialog = false
      // this.listado = []
      // this.item = []
      // for (let i = 0; i < this.item2.length; i++) {
      //   this.item.push(this.item2[i])
      // }
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    // validarCampos () {
    //   if (this.form.descripcion === '') {
    //     this.$swal({
    //       icon: 'error',
    //       title: 'Formulario incompleto',
    //       text: 'Por favor llene el campo para continuar'
    //     })
    //     return true
    //   } else {
    //     if (this.form.descripcion.length > 20) {
    //       this.$swal({
    //         icon: 'error',
    //         title: 'Error!',
    //         text: 'Ha excedido el limite de caracteres'
    //       })
    //       return true
    //     }
    //   }
    //   return false
    // },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    // save () {
    //   if (!this.validarCampos()) {
    //     this.$swal({
    //       title: 'Cargando...',
    //       html: 'Esperando respuesta del servidor',
    //       allowOutsideClick: false,
    //       onBeforeOpen: () => {
    //         this.$swal.showLoading()
    //       }
    //     })
    //     if (this.editedIndex > -1) {
    //       Api.put('tipoEmpleado', this.form)
    //         .then(response => {
    //           this.$swal({
    //             icon: 'success',
    //             title: 'Modificación exitosa',
    //             text: 'Todos los datos han sido guardados'
    //           })
    //           this.listarTipo()
    //           this.close()
    //         })
    //         .catch(error => {
    //           if (error.response) {
    //             this.$swal({
    //               icon: 'error',
    //               title: 'Error al modificar',
    //               text: 'Por favor, verifique los datos e intente de nuevo'
    //             })
    //           } else if (error.request) {
    //             this.$swal({
    //               icon: 'error',
    //               title: 'Error de red',
    //               text: 'Por favor verique su conexion de internet'
    //             })
    //           } else {
    //             console.log('Error', error.message)
    //           }
    //         })
    //       Object.assign(this.tipoEmpleado[this.editedIndex], this.form)
    //     } else {
    //       Api.post('tipoEmpleado', this.form)
    //         .then(response => {
    //           this.$swal({
    //             icon: 'success',
    //             title: 'Inclusion exitosa',
    //             text: 'Todos los cambios han sido guardados'
    //           })
    //           this.tipoEmpleado.push(response.data)
    //           this.listarTipo()
    //           this.close()
    //         })
    //         .catch(error => {
    //           if (error.response) {
    //             this.$swal({
    //               icon: 'error',
    //               title: 'Error al guardar',
    //               text: 'Por favor, verifique los datos e intente de nuevo'
    //             })
    //           } else if (error.request) {
    //             this.$swal({
    //               icon: 'error',
    //               title: 'Error de red',
    //               text: 'Por favor verique su conexion de internet'
    //             })
    //           } else {
    //             console.log('Error', error.message)
    //           }
    //         })
    //     }
    //   }
    // }
  }
}
</script>
